import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=0f576090&scoped=true&lang=html"
import script from "./BlogItem.vue?vue&type=script&lang=js"
export * from "./BlogItem.vue?vue&type=script&lang=js"
import style0 from "./BlogItem.vue?vue&type=style&index=0&id=0f576090&prod&lang=scss&scoped=true"
import style1 from "@/assets/styles/normalize.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f576090",
  null
  
)

export default component.exports